<template>
  <div>
    <div class="base-input ovf-hd conmon-top" style="margin-bottom: 10px;">
        <el-collapse-transition>
          <div class="search-content common-search-formtype" style="line-height: 60px">
            <div class="demo-input-suffix" style="text-align: left;margin-left: 32px">
              公众号切换：
              <el-select v-model="original_id" placeholder="请选择" @change='getData()'>
                <el-option
                  v-for="item in publicNumber"
                  :key="item.original_id"
                  :label="item.nick_name"
                  :value="item.original_id">
                </el-option>
              </el-select>
            </div>
          </div>
        </el-collapse-transition>
    </div>
    <el-row class="search-title common-table-top" style="padding-right:0">
      <el-col :span="4" style="text-align: left;">
        <i class="el-icon-document" style="font-weight: bold;"></i>
        <span class="order-list-search-span">数据列表</span>
      </el-col>
      <el-col :span="20" class="text-align-right">
        <el-button v-if="butsObj.status_change" type="primary" class="add-btn btn-right" style="float: right;margin-left: 0" @click='postMenu'>启用菜单</el-button>
<!--        <router-link v-if="butsObj.add" :to="{path:'/home/custom-menu-add',query:{ original_id: original_id, public_id: public_id}}">-->
          <el-button type="primary" class="add-btn list-btn-margin" @click="menuAddWay" style="float: right;">添加菜单</el-button>
<!--        </router-link>-->
      </el-col>
    </el-row>
    <el-row class="import-data-title table-first-style">
      <el-table
       class="table"
       v-loading="loading"
      :data="tableData">
        <template slot="empty">
          <div class="newTableEmpty">暂无数据，去<span @click="menuAddWay">新建</span></div>
        </template>
        <el-table-column
          prop="keyword"
          label="名称">
        </el-table-column>
        <el-table-column
          prop="menutype"
          label="按钮类型">
        </el-table-column>
        <el-table-column
          width="130"
          label="操作">
          <template slot-scope="scope">
            <router-link v-if="butsObj.edit" :to="{ path: '/home/custom-menu-add' , query: { id: scope.row.id, public_id: public_id}}">
              <div class="op-link editColor">
                编辑
              </div>
            </router-link>
            <div v-if="butsObj.del" class="op-link deleteColor" @click='delMenuApi(scope.row.id)'>
              删除
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
  </div>
</template>

<script>
import { menuIndexApi, delMenuApi, postMenu } from '@/api/customer.js'
import { butonsList, getMenId } from '@/api/analyse.js'
export default {
  name: 'publicNumber',
  data () {
    return {
      loading: true,
      tableData: [],
      publicNumber: [],
      original_id: '',
      public_id: '',
      butsObj: { // button按钮列表
        status_change: false,
        add: false,
        edit: false,
        del: false
      }
    }
  },
  mounted () {
    rule.publicNumber((res) => {
      for (let item of res.data.data.list) {
        if (item.is_disable === 0) {
          this.publicNumber.push(item)
        }
        if (item.is_default === 1) {
          this.original_id = item.original_id
          this.public_id = item.id
        }
      }
    })
    this.getData()
    this.getButtonsList()
  },
  methods: {
    // 点击新建
    menuAddWay () {
      router.push({path:'/home/custom-menu-add',query:{ original_id: this.original_id, public_id: this.public_id}})
    },
    // 获取可用菜单按钮列表
    getButtonsList () {
      let params = {
        systemCode: 'ZY_INTELLIQUOR',
        authKey: Lockr.get('authKey'),
        sessionId: Lockr.get('sessionId'),
        menuId: getMenId(this.$route.path)
      }
      butonsList(params).then(res=>{
        if (res.data.code === '200') {
          let result = res.data.result || []
          let arrObj = Object.keys(this.butsObj)
          let newarr  = result.map((item)=>{
            return item.perms
          })
          arrObj.map(it=> {
            if (newarr.indexOf(it)!==-1) {
              this.butsObj[it] = true
            } else {
              this.butsObj[it] = false
            }
          })
        }
      }).catch(err=>{
        this.$message.error(err)
      })
    },
    getData() {
      this.loading = true
      for (let item of this.publicNumber) {
        if (item.original_id == this.original_id) {
          this.public_id = item.id
        }
      }
      let data = {
        original_id: this.original_id
      }
      menuIndexApi(data).then((res) => {
        if (res.data.code === 0) {
          console.log(res.data)
          for (let item of res.data.data) {
            if (item.level !== 0) {
              item.keyword = item.keyword.slice(item.keyword.indexOf('└'))
            }
          }
          this.tableData = res.data.data
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
      this.openLoading()
    },
    // 数据加载时的动画
    openLoading() {
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    // 启用菜单
    postMenu() {
      postMenu().then((res) => {
        if (res.data.code === 0) {
          _g.toastMsg('success', '启用成功')
          this.getData()
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // 删除
    delMenuApi(id) {
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let data = {
          id: id
        }
        delMenuApi(data).then((res) => {
          if (res.data.code === 0) {
            _g.toastMsg('success', '删除成功')
            this.getData()
          } else {
            _g.toastMsg('error', res.data.error)
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    }
  },
  created() {
  }
}
</script>

<style scoped>
.sign-manage-title {
  background: #ecf6ff;
  border: 1px solid #E4e4e4;
  height:60px;
  padding:10px;
  line-height: 40px;
  margin-top: 10px;
}
.green{
  color: green;
}
.red{
  color: red;
}
.table-title {
  text-align: left;
}
.dialog-content {
  height: 200px;
}
.content-one span {
  display: inline-block;
  float: left;
  line-height: 20px;
  font-size: 16px;
  margin-top: 10px;
}
.content-one p {
  text-align: left;
}
.search-flod-content{
  border: 1px solid #ebebeb;
}
</style>
